import React from 'react';
import { useGetUserBookmarksQuery } from '../../apis';
import { Spinner, SpinnerVariants } from '../../UI';
import { QuestionCard } from '../../components/QuestionCard/QuestionCard.tsx';

export const UserBookmarks: React.FC = () => {

  const { data, isLoading } = useGetUserBookmarksQuery();

  if (isLoading) {
    return <div className='flex justify-center'>
      <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
    </div>;
  }

  return (
    <>
      {
        data?.length === 0
          ? <div className='text-white mt-app-base text-app-lg flex justify-center'>
            <p>You don&apos;t have any bookmarks</p>
          </div>
          : null
      }
      {
        data?.map((question) => {
          return <QuestionCard data={question} key={question.questionId} />;
        })
      }
    </>
  );
};
